import React from 'react';
import { Card, Form } from 'react-bootstrap';
import { CronJobFilterStatus } from '../../../../infrastructure/CronJobClient';
import type { CronJobFiltersProps } from './types';

const CronJobFilters: React.FC<CronJobFiltersProps> = ({ selectedStatus, onStatusChange, totalCronJobs }) => {
  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onStatusChange(e.target.value as CronJobFilterStatus);
  };

  const getStatusDisplayText = (status: CronJobFilterStatus) => {
    switch (status) {
      case CronJobFilterStatus.ENABLED:
        return 'Enabled';
      case CronJobFilterStatus.DISABLED:
        return 'Disabled';
      default:
        return 'Unknown';
    }
  };

  return (
    <Card className="mb-4">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center m-2">
          <div className="d-flex align-items-center gap-3">
            <Form.Select value={selectedStatus} onChange={handleStatusChange} style={{ width: '200px' }}>
              <option value={CronJobFilterStatus.ENABLED}>Enabled CronJobs</option>
              <option value={CronJobFilterStatus.DISABLED}>Disabled CronJobs</option>
            </Form.Select>
            <span className="text-muted">Showing {getStatusDisplayText(selectedStatus)} cron jobs</span>
          </div>
          <div className="text-muted">Total {totalCronJobs} cron jobs</div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CronJobFilters;
